import { formatDuration } from "../../../utils/time";
import { subjects } from "../utils/data";

export function TestCard({ exam, evaluateExam }) {
  return (
    <div className="rounded-xl p-6 transition-all duration-200 hover:shadow-xl bg-white/95 border border-yellow-400/20">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <h3
          className="text-uppercase !text-left flex-1 pr-3"
          style={{
            fontSize: "1.25rem",
            fontWeight: "bolder !important",
            color: "#111827",
          }}
        >
          {exam.examName || "Mock Test"}
        </h3>

        <a style={{textDecoration:"none",color:"#111827"}} href={exam?.documents?.[0]?.url} target="_blank">
          <button
            style={{ borderRadius: "6px" }}
            className="flex items-center gap-2 px-2 h-9 text-sm font-medium border border-gray-300 bg-white hover:bg-gray-100 hover:text-accent-foreground transition"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <span className="font-[500]">View Paper</span>
          </button>
        </a>
      </div>

      {/* Tags */}
      <div className="w-fit flex flex-wrap gap-2 text-xs mb-3">
        <span className="px-3 py-1 rounded-full font-medium bg-[#1a2332] text-yellow-400">
          {subjects[exam.subject]}
        </span>

        <span className="px-3 py-1 rounded-full font-medium bg-green-50 text-green-700">
          {exam.examSet}
        </span>
        {/* Duration */}
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 text-[#1a2332]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span>{formatDuration(exam.duration)}</span>
        </div>
      </div>

      {/* Action */}
      <button
         onClick={evaluateExam}
        style={{ borderRadius: "8px", fontSize: "0.9rem" }}
        className="w-full py-2.5 font-semibold bg-yellow-400 text-[#0f1923] hover:bg-yellow-300 transition"
      >
        Evaluate
      </button>
    </div>
  );
}
